var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-perm"},[_c('el-alert',{attrs:{"type":"error","closable":false,"show-icon":""}},[_c('template',{slot:"title"},[_c('p',{staticClass:"title"},[_vm._v("抱歉，您无权限浏览此模块～")])])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }